import { render, staticRenderFns } from "./ContentSticky.vue?vue&type=template&id=2ccc596c&"
import script from "./ContentSticky.vue?vue&type=script&lang=js&"
export * from "./ContentSticky.vue?vue&type=script&lang=js&"
import style0 from "./ContentSticky.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports